export default __webpack_public_path__ + "static/media/IT_2.b92e0ed6.jpg";